<div fxFill fxLayout="column" fxLayoutAlign="start center">
    <div fxFlex="70px" fxLayout="row" fxLayoutAlign="space-between" style="width: 100%">
        <div fxFlex>
            <h3>{{ data?.bill?.billItems[0].description + "-" + (data?.bill?.amount | currency: "BRL") }}</h3>
        </div>
        <div fxFlex="40px">
            <button mat-icon-button (click)="close()">
                <mat-icon color="primary"> close </mat-icon>
            </button>
        </div>
    </div>
    <div fxFlex fxLayout="column" fxLayoutAlign="space-around" fxLayoutGap="10px" style="width: 100%">
        <mat-card>
            <mat-card-header>
                <mat-card-title>{{ "BILLING.CANCEL_BILLING.TEXT" | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form name="cancelBillForm" [formGroup]="cancelBillForm">
                    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="8px">
                        <mat-form-field appearance="outline" fxFlex style="width: 100%">
                            <mat-label>{{ "BILLING.CANCEL_BILLING.COMMENTS" | translate }}</mat-label>
                            <textarea
                                matInput
                                formControlName="comments"
                                [(ngModel)]="comments"
                                maxlength="100"
                                rows="5"
                            ></textarea>
                            <mat-hint align="end"> {{ comments?.length || 0 }} / 100 </mat-hint>
                        </mat-form-field>
                    </div>
                </form>
            </mat-card-content>
            <mat-card-actions align="end">
                <button
                    mat-flat-button
                    color="warning"
                    [class.spinner]="isLoading"
                    [disabled]="isLoading"
                    [disabled]="cancelBillForm.invalid || cancelBillForm.pristine"
                    (click)="cancelBillClick()"
                >
                    {{ "BILLING.CANCEL_BILLING.BUTTON" | translate }}
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
